.root {
  background: linear-gradient(
    135deg,
    var(--alternate-text-color, var(--mantine-color-gray-4)),
    var(--mantine-color-text),
    var(--alternate-text-color, var(--mantine-color-gray-4))
  );
  background-clip: text;
  color: transparent;
  background-size: 300% 100%;
  animation: shimmer 3s linear infinite;
  line-height: normal !important;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

[data-mantine-color-scheme="dark"] .root {
  --alternate-text-color: var(--mantine-color-dark-3);
}
